import { ensureCsrfCookie, getCsrfToken } from '@/lib/auth-api'

/**
 * Mutator orvala: każde żądanie z cookies, mutacje z tokenem CSRF
 * (SessionAuthentication DRF wymaga go dla uwierzytelnionych sesji).
 */
export async function customFetch<T>(url: string, init: RequestInit): Promise<T> {
  const method = (init.method ?? 'GET').toUpperCase()
  const headers = new Headers(init.headers)
  if (method !== 'GET') {
    await ensureCsrfCookie()
    headers.set('X-CSRFToken', getCsrfToken() ?? '')
  }
  const response = await fetch(url, { ...init, headers, credentials: 'include' })
  if ([204, 205, 304].includes(response.status)) {
    return { data: {}, status: response.status, headers: response.headers } as T
  }
  // File downloads (credential sheets: application/pdf, xlsx) return a binary body
  // that must not be text-decoded/JSON-parsed. Everything else is JSON.
  const contentType = response.headers.get('content-type') ?? ''
  if (contentType && !contentType.includes('application/json')) {
    const data = await response.blob()
    return { data, status: response.status, headers: response.headers } as T
  }
  const body = await response.text()
  const data = body ? JSON.parse(body) : {}
  return { data, status: response.status, headers: response.headers } as T
}
